import React, { useState } from 'react';
import { Alert, AlertIcon, Box, Button, Link } from '@chakra-ui/react';
import Plugin, { PluginProps } from '../Plugin';

const getDataTypeProps = (dataType: string) => {
  const dataTypeProps: Record<string, any> = {
    none: {
      status: 'success',
      color: 'gray',
    },
    todo: {
      status: 'success',
      color: 'green',
    },
    error: {
      status: 'error',
      color: 'red',
    },
    danger: {
      status: 'error',
      color: 'red',
    },
    warning: {
      status: 'warning',
      color: 'orange',
    },
    info: {
      status: 'info',
      color: 'blue',
    },
  };
  return dataTypeProps[dataType];
};

const HighlightSection = (props: PluginProps) => {
  const { content } = props;

  const color = content.data.background_color;

  const [dataTypeProps, setDataTypeProps] = useState(
    getDataTypeProps(content.data.type),
  );

  const changeDataTypeProps = (dataType: string) => {
    setDataTypeProps(getDataTypeProps(dataType));
  };

  return (
    <Box
      borderWidth={2}
      borderColor={color ? color : dataTypeProps.color}
      borderRadius={4}
      overflow="hidden"
    >
      <Alert
        status={dataTypeProps.status}
        backgroundColor={color}
        variant="solid"
      >
        <AlertIcon />
        {content.data.title}
      </Alert>

      <Box p={4}>
        {content.children.map((child, index) => {
          return (
            <Plugin
              key={index}
              {...props}
              content={child}
              changeHighlightSectionType={changeDataTypeProps}
            />
          );
        })}
        {content.data.editor_link && (
          <div style={{ width: '100%', textAlign: 'center' }}>
            <Link href={content.data.editor_link} target="_blank">
              <Button size="lg" colorScheme="blue">
                {content.data.editor_link_label}
              </Button>
            </Link>
          </div>
        )}
      </Box>
    </Box>
  );
};

export default HighlightSection;
